module.exports = __webpack_public_path__ + "static/details-12-8e5d1a0274c13e57ce64a8131bafed25.jpg";